import BackNavigationButton from "../../../basic/backNavigationButton/BackNavigationButton";
import ContentWithHeader from "../../../wrapper/ContentWithHeader/ContentWithHeader";
import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";

interface SchoolClassPageLayoutProps {
    backLabel: string;
    onBack: () => void;
    rightLabel?: string;
    fullWidth?: boolean;
    noPadding?: boolean;
    "data-testid"?: string;
    children: React.ReactNode;
    bottomContent?: React.ReactNode;
}

const SchoolClassPageLayout = (props: SchoolClassPageLayoutProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const spacingClasses = getStyleBasedOnBreakpoint(Breakpoint.MD, "gap-xxl pt-l px-l", "gap-l pt-m px-m");
    const bottomSpacingClass = props.bottomContent
        ? getStyleBasedOnBreakpoint(Breakpoint.MD, "pb-xxl", "pb-l")
        : "pb-m";

    return (
        <ContentWithHeader
            isAreaHeader
            noPadding={!!props.bottomContent || props.noPadding}
        >
            <div
                className="flex flex-col flex-1 w-full"
                data-testid={props["data-testid"]}
            >
                <div className={`flex flex-col flex-1 w-full ${spacingClasses} ${bottomSpacingClass}`}>
                    <div className="flex justify-between items-center">
                        <BackNavigationButton
                            label={props.backLabel}
                            onClick={props.onBack}
                        />
                        {props.rightLabel && <span className="text-l text-p6-grey-dark">{props.rightLabel}</span>}
                    </div>

                    <div
                        className="flex flex-col flex-1 w-full mx-auto gap-l items-center"
                        style={
                            props.fullWidth
                                ? undefined
                                : { maxWidth: `${process.env.REACT_APP_UPPER_GRID_STEP_BORDER}px` }
                        }
                    >
                        {props.children}
                    </div>
                </div>

                {props.bottomContent}
            </div>
        </ContentWithHeader>
    );
};

export default SchoolClassPageLayout;
